<template>
  <div class="letter">
    <div class="letter-list van-hairline--top">
      <div 
        v-for="(item,index) in letterList" 
        :key="item.ChildrenID" 
        class="letter-list-flex van-hairline--bottom"
        @click="viewMsgInfo(item,index)">
        <div class="letter-list-picture">
          <img :src="item.ReceiverIcon?(api+item.ReceiverIcon):require('@/assets/parent/att.png')" alt="">
        </div>
        <div class="letter-list-right">
          <div class="letter-list-right-top">
            <div class="letter-list-name">{{item.ReceiverName}}</div>
            <div class="letter-list-time">{{item.CreateByDateName}}</div>
          </div>
          <div class="letter-list-right-bottom">
            <div class="letter-list-right-bottom-text nowrap">{{item.PrivateLetterBody}}</div>
            <div class="letter-list-right-bottom-tips" v-if="item.Unread>0">{{item.Unread}}</div>
          </div>
        </div>
      </div>
    </div>
    <letter-info :isShow="isShow" :userInfo="userInfo" :rows="rows" @listenToChildClose="closeModal"></letter-info>
  </div>
</template>
<script>
import LetterInfo from '@/pages/common/views/xy/parent/LetterInfo'
export default {
  name:'letter',
  components: {
    LetterInfo
  },
  data () {
    return {
      isShow:false,
      rows:{},
      letterList:[],
      userInfo:{},
      api:''
    }
  },
  created () {
    this.letterList=this.$store.state.parentInfo.childList
    this.userInfo = this.$store.state.parentInfo.userInfo//获取当前登录用户信息
    this.api=this.xyMApi
  },
  methods: {
    viewMsgInfo(val,i) {
      this.isShow = true
      this.rows = val
      val.Unread = 0;
      this.$store.commit('parentInfo/changeChatIndex', i)//存储当前会话index
      this.getChatMsg(val)
    },
    closeModal (val) {// 监听子组件关闭事件
      this.isShow = val
      this.$store.commit('parentInfo/changeChatIndex', -1)//重置会话index
      this.$store.commit('parentInfo/changeMsgList', [])//消息列表置空
    },
    async getChatMsg(val){
      let res = await this.xyapi.get(`${this.xyMApi}/api/InstantMessaging/GetPrivateLetterByUser?ReceiverID=${val.ReceiverID}`, null);
      if(res.success) {
        if (res.data.length>0) {
          res.data.map((item)=>{
            if (item.SenderID === this.userInfo.UserID){
              if (this.userInfo.IconFull) {
                this.$set(item, 'ReceiverIcon', this.userInfo.IconFull)
              } else {
                this.$set(item, 'ReceiverIcon', '')
              }
            } else {
              if (val.ReceiverIcon) {
                this.$set(item, 'ReceiverIcon', val.ReceiverIcon);
              } else {
                this.$set(item, 'ReceiverIcon', '');
              }
            }            
          })
          this.$store.commit('parentInfo/changeMsgList', res.data)
          var sendOption = {
            ReceiverID: val.ReceiverID,
            MessageType: 2,
            MessageBody: ''
          };
          this.$parent.websocketsend(JSON.stringify(sendOption));
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.letter{
  display: flex;
  flex-flow: column;
  .header-style {
    height: 80px;
    color: #333;
    background: #fff;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 100px;
    font-size: 30px;
  }
  .letter-list{
    overflow-y: auto;
    margin-top: 20px;
    .letter-list-flex{
      display: flex;
      align-items: center;
      height: 134px;
      padding: 0 20px;
      background: #fff;
      .letter-list-picture{
        width:88px;
        height: 88px;
        border-radius: 8px;
        margin-right: 20px;
        img {
          border-radius: 8px;
          width:100%;
          height: 100%;
        }
      }
      .letter-list-right{
        flex: 1;
        .letter-list-right-top{
          display: flex;
          justify-content:space-between;
          margin-bottom: 14px;
          .letter-list-name{
            color:#333;
            font-size: 28px;
          }
          .letter-list-time{
            color:#999;
            font-size: 20px;
          }
        }
        .letter-list-right-bottom{
          display: flex;
          justify-content: space-between;
          .letter-list-right-bottom-text{
            font-size: 24px;
            color: #999;
            width: 500px;
            padding-bottom:10px;
          }
          .letter-list-right-bottom-tips{
              width: 30px;
            height: 30px;
            line-height: 30px;
            border-radius: 50%;
            background: #ef4f4f;
            color: #fff;
            text-align: center;
          }
        }
      }      
    }
  }
}
</style>
